<template>
    <div>
        <div class="favorite-empty"v-if="!complexesLoading && !propertiesLoading && !complexesExist && !propertiesExist">
            {{ 'You have not added any real estate to favorites, to add, click on' | trans }}
            <span class="favorite-empty__icon"></span>
            <a :href="this.$root.baseUrl + '/complexes'" class="favorite-empty__link blue-btn">
                {{ 'Go to Catalog' | trans }}
            </a>
        </div>
        <div class="loader-container" v-if="complexesLoading || propertiesLoading">
            <loader-gray></loader-gray>
        </div>

        <div class="page-favorite__body" v-if="!complexesLoading && !propertiesLoading">
            <div class="page-favorite__list">
                <component
                    v-for="item in complexesAndPropertiesPerPage"
                    :key="item.type + item.id + 'favorite'"
                    :is="(item.type === 'complexId') ? 'catalog-complex-card' : 'catalog-property-card'"
                    :complex="(item.type === 'complexId') ? findComplex(item.id) : null"
                    :property="(item.type === 'propertyId') ? findProperty(item.id) : null"
                    :is-slider="false"
                />
            </div>
        </div>

        <div class="catalog-list__footer">
            <catalog-list-pagination
                v-if="(!complexesLoading && complexesExist) || (!propertiesLoading && propertiesExist)"
                :paginator="paginationLinks"
                @page-changed="changePage">
            </catalog-list-pagination>
        </div>

        <button
            v-if="complexesExist || propertiesExist"
            class="page-favorite__reset"
            @click="deleteAll"
        >
            {{ 'Clear all' | trans }}
        </button>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import {catalogComplexesIndex, catalogPropertiesIndex} from "../../api/catalog"
import LoaderGray from "../loaders/LoaderGray.vue";
import Swiper, { EffectFade, Navigation, Pagination } from "swiper";

export default {
    name: "CatalogListFavorites",
    components: {LoaderGray},

    data() {
        return {
            complexesLoading: false,
            propertiesLoading: false,
            complexes: [],
            properties: [],
            swiper: null,
            perPage: 12
        }
    },

    computed: {
        ...mapGetters({
            isLoadedIds: 'favorites/isLoaded',
            estateIds: 'favorites/favoritesIds',
        }),
        complexesExist() {
            return Array.isArray(this.estateIds.complexes) && this.estateIds.complexes.length > 0
        },
        propertiesExist() {
            return Array.isArray(this.estateIds.properties) && this.estateIds.properties.length > 0
        },
        currentPageNumber() {
            let pageNumber = parseInt(new URLSearchParams(window.location.search).get('page'));
            if (!pageNumber) return 1;
            return pageNumber;
        },
        paginationLinks() {
            const total = this.estateIds.complexes.length + this.estateIds.properties.length;
            return {
                current_page: this.currentPageNumber,
                last_page: Math.ceil(total / this.perPage),
                per_page: this.perPage,
                total: total
            };
        },
        complexesAndPropertiesPerPage() {
            this.complexesLoading = true;
            this.propertiesLoading = true;
            let commonArray = [];
            if (Array.isArray(this.estateIds.complexes)) {
                this.estateIds.complexes.forEach(function(complexId, index, array) {
                    commonArray.push({
                        id: complexId,
                        type: 'complexId'
                    });
                });
            }
            if (Array.isArray(this.estateIds.properties)) {
                this.estateIds.properties.forEach(function(propertyId, index, array) {
                    commonArray.push({
                        id: propertyId,
                        type: 'propertyId'
                    });
                });
            }

            // возвращаем id только тех элементов, которые должны быть
            // отображены на текущей странице пагинации
            const leftIndex = (this.currentPageNumber - 1) * this.perPage;
            const rightIndex = leftIndex + 12;

            // если для текущей страницы пагинации не осталось объектов
            // переходим на предыдушую страницу
            if (commonArray.length > 0 && commonArray.slice(leftIndex, rightIndex).length === 0){
                let url = new URL(window.location.href);

                if (!(this.currentPageNumber - 1)) url.searchParams.set('page', 1);
                else url.searchParams.set('page', (this.currentPageNumber - 1));

                window.location.href = url.toString();
            }

            return commonArray.slice(leftIndex, rightIndex);
        }
    },

    watch: {
        async estateIds(val) {
            await this.loadComplexesAndProperties(val);
            this.$nextTick(() => {
                this.initSwiperImages();
            });
        }
    },

    methods: {
        changePage(page){
            const url = new URL(window.location.href);
            url.searchParams.set('page', page);
            window.location.href = url.toString();
        },
        findComplex(id) {
            return this.complexes.find(function (complex) {
                return complex.id === id;
            });
        },
        findProperty(id) {
            return this.properties.find(function (property) {
                return property.id === id;
            });
        },
        async loadComplexesAndProperties(val) {
            await this.getComplexes();
            await this.getProperties();
        },
        async getComplexes() {
            // только нужные для страницы объекты
            let complexesIds = [];

            this.complexesAndPropertiesPerPage.forEach(function(object, index, array) {
                if (object['type'] === 'complexId')
                    complexesIds.push(object['id']);
            });

            const complexes = await catalogComplexesIndex({
                ids: complexesIds,
                currency: window.currentCurrency
            });
            if (Array.isArray(complexes)) {
                this.complexes = complexes;
            } else {
                this.complexes = [];
            }
            this.complexesLoading = false;
        },
        async getProperties() {
            // только нужные для страницы объекты
            let propertiesIds = [];

            this.complexesAndPropertiesPerPage.forEach(function(object, index, array) {
                if (object['type'] === 'propertyId')
                    propertiesIds.push(object['id']);
            });

            const properties = await catalogPropertiesIndex({
                ids: propertiesIds,
                currency: window.currentCurrency
            });
            if (Array.isArray(properties)) {
                this.properties = properties;
            } else {
                this.properties = [];
            }
            this.propertiesLoading = false;
        },
        async deleteAll() {
            await this.$store.dispatch('favorites/deleteAll');
        },
        initSwiperImages() {
            let arrsPrev = document.querySelectorAll(".card-button_prev");
            let arrsNext = document.querySelectorAll(".card-button_next");
            let cardSlider = document.querySelectorAll(".card__slider");

            for (let index = 0; index < cardSlider.length; index++) {
                const slider = cardSlider[index];
                new Swiper(slider, {
                    modules: [Pagination, EffectFade, Navigation],
                    observer: true,
                    observeParents: true,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    speed: 800,
                    watchOverflow: true,
                    effect: "fade",
                    pagination: {
                        el: slider.querySelector('.swiper-pagination'),
                        clickable: true,
                    },
                    navigation: {
                        prevEl: arrsPrev[index],
                        nextEl: arrsNext[index]
                    },
                    breakpoints: {
                        320: {},
                        768: {
                            touchRatio: 0,
                            navigation: {
                                prevEl: ".card-button_prev",
                                nextEl: ".card-button_next"
                            }
                        }
                    },
                });
            }
        }
    }
}
</script>

<style lang="scss">
.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50%;
    margin: 0 auto;
    height: 607px;
}
</style>
